export default "__VITE_ASSET__CpEC810z__"